// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__hw3NJ","title":"Images45_title__mhRrX","images":"Images45_images__3OtAM"};